import { render } from "./SimpleLoader.vue?vue&type=template&id=13c4945c&scoped=true"
import script from "./SimpleLoader.vue?vue&type=script&lang=js"
export * from "./SimpleLoader.vue?vue&type=script&lang=js"

import "./SimpleLoader.vue?vue&type=style&index=0&id=13c4945c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c4945c"]])

export default __exports__